<template>
  <div class="popup-entry-main">
    <div class="popup-content">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div class="close-button">
          <button @click="closeClick()">X</button>
        </div>
      </div>
      <div class="body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';

export default {
  components: {
    Input
  },
  props: {
    title: { type: String, default: 'Title here' },

    createdBy: { type: String, default: 'createdby' },
    updatedBy: { type: String, default: 'createdby' },
  },
  methods: {
    closeClick() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.popup-entry-main {
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $top-nav-height;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 42px;
  z-index: 99999;

  > .popup-content > * {
    padding: 5px;
  }

  > .popup-content {
    width: 100%;
    height: 95%;
    background-color: white;
    border-radius: 3px;
    display: flex;
    flex-direction: column;

    > .header {
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgb(180,180,180);
      
      > .title {
        flex-grow: 1;
        margin-left: 10px;
        font-weight: bolder;
      }

      > .dates {
        display: flex;

        > .dates-input {
          margin: 0 3px;
        }
      }

      > .close-button {
        margin: 0px 5px;

        > button {
          background: red;
          color: white;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }

    > .body {
      overflow-y: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

  }
}
</style>